import { PageProgressType } from 'data/types';

export type ChooseSystemsGateParams = {
  systemDesignLocked: boolean;
  pageProgress: Pick<PageProgressType, 'structure' | 'configurations'>;
};

export function isChooseSystemsPrerequisiteComplete({
  systemDesignLocked,
  pageProgress
}: ChooseSystemsGateParams): boolean {
  return systemDesignLocked
    ? pageProgress.structure === 100
    : pageProgress.configurations === 100;
}
